<template>
    <v-container fluid>
        <v-layout class="hide-on-print" row wrap>
            <v-flex lg12>
                <v-card>
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title>
                            Trekking Request Detail
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-chip v-if="trekkingData.statusCode === 2" color="green darken-1" text-color="white">
                            Approved
                        </v-chip>
                        <v-chip v-else-if="trekkingData.statusCode === 47" color="primary darken-1" text-color="white">
                            Verified
                        </v-chip>
                        <v-chip v-else-if="trekkingData.statusCode === 1" color="green" text-color="white">Paid</v-chip>
                        <v-chip v-else-if="trekkingData.statusCode === 36" color="red" text-color="white">Rejected
                        </v-chip>
                        <v-chip v-else color="red" text-color="white">Pending</v-chip>
                    </v-toolbar>

                    <v-card-text>
                        <v-layout row wrap v-if="trekkingData.trekkingRoute">
                            <v-flex xs12 class="px-2" v-if="trekkingData.rejected_remarks">
                                <v-alert outlined type="error">
                                    This trekking request has been rejected.
                                    <span class="">({{ trekkingData.rejected_remarks }})</span>
                                </v-alert>
                            </v-flex>

                            <confirmation-header-text class="ml-2" icon="mdi-alpha-t-box" text="Trekking Route"/>

                            <v-flex sm3 xs12>
                                <list-item-detail :sub_title="'T' + trekkingData.id" title="Submission No.">
                                </list-item-detail>
                            </v-flex>
                            <v-flex sm3 xs12>
                                <list-item-detail :sub_title="trekkingData.trekkingRoute.name" title="Trekking Route">
                                </list-item-detail>
                            </v-flex>
                            <v-flex sm3 v-if="trekkingData.no_of_days" xs12>
                                <list-item-detail :sub_title="trekkingData.no_of_days" title="Number Of Days">
                                </list-item-detail>
                            </v-flex>
                            <v-flex sm3 v-if="trekkingData.starting_date" xs12>
                                <list-item-detail :sub_title="trekkingData.starting_date" title="Starting Date">
                                </list-item-detail>
                            </v-flex>

                            <v-flex sm3 v-if="trekkingData.iternary_file_url" xs12>
                                <file-list-item-detail
                                    :avatar="true"
                                    :src="trekkingData.iternary_file_url"
                                    sub_title="Iternary File"
                                />
                            </v-flex>

                            <v-flex xs12>
                                <v-divider class="my-3"/>
                            </v-flex>

                            <confirmation-header-text class="ml-2" icon="mdi-account" text="Trekker's Info:"/>

                            <v-flex class="pt-0" xs12>
                                <v-simple-table class="mx-4" light>
                                    <thead>
                                    <tr>
                                        <th class="text-left">Name</th>
                                        <th class="text-left">Country</th>
                                        <th class="text-left">Passport number</th>
                                        <th class="text-left">Validity</th>
                                        <th class="text-left">Visa Status</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr :key="item.passport_number" v-for="item in trekkingData.trekkers">
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.country }}</td>
                                        <td>{{ item.passport_number }}</td>
                                        <td>{{ item.validity }}</td>
                                        <td>{{ item.visa ? 'Approved' : 'Unapproved' }}</td>
                                    </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-flex>
                            <v-flex xs12>
                                <v-divider class="my-3"/>
                            </v-flex>

                            <confirmation-header-text class="ml-2" icon="mdi-account" text="Nepali Guide Info:"/>
                            <template v-for="guide in trekkingData.guides">
                                <v-flex :key="'g'+guide.id" sm3 xs12>
                                    <list-item-detail :sub_title="guide.name" title="Full Name">
                                    </list-item-detail>
                                </v-flex>
                                <v-flex :key="'g1'+guide.id" sm3 xs12>
                                    <list-item-detail :sub_title="guide.mobile_number" title="Mobile Number">
                                    </list-item-detail>
                                </v-flex>
                                <v-flex :key="'g2'+guide.id" sm3 xs12>
                                    <list-item-detail :sub_title="guide.citizenship_number" title="Citizenship No">
                                    </list-item-detail>
                                </v-flex>
                                <v-flex :key="'g4'+guide.id" sm3 xs12>

                                    <v-list-item-subtitle style="font-size: 12px; user-select: text;">Insurance File
                                    </v-list-item-subtitle>
                                    <file-display v-if="guide.insurance_file"
                                                  :src="guide.insurance_file"
                                                  sub_title="Insurance File">
                                    </file-display>

                                </v-flex>
                            </template>

                            <v-flex xs12>
                                <v-divider class="my-3"/>
                            </v-flex>

                            <confirmation-header-text class="ml-2" icon="mdi-account" text="Porter's Info:"/>
                            <template v-for="(porter) in trekkingData.porters">
                                <v-flex :key="'p'+porter.id" sm3 xs12>
                                    <list-item-detail :sub_title="porter.name" title="Full Name:">
                                    </list-item-detail>
                                </v-flex>
                                <v-flex :key="'p1'+porter.id" sm3 xs12>
                                    <list-item-detail :sub_title="porter.mobile_number" title="Mobile Number:">
                                    </list-item-detail>
                                </v-flex>
                                <v-flex :key="'p2'+porter.id" sm3 xs12>
                                    <list-item-detail :sub_title="porter.citizenship_number" title="Citizenship No:">
                                    </list-item-detail>
                                </v-flex>

                                <v-flex :key="'p4'+porter.id" sm3 xs12>
                                    <v-list-item-subtitle style="font-size: 12px; user-select: text;">Insurance File
                                    </v-list-item-subtitle>
                                    <file-display
                                        :src="porter.insurance_file"
                                        sub_title="Insurance File">
                                    </file-display>
                                </v-flex>
                            </template>

                            <v-flex xs12>
                                <v-divider class="my-3"/>
                            </v-flex>

                            <payment-detail
                                :payment_detail="trekkingData.payment_detail"
                                :total_cost=trekkingData.total_cost
                                :total_cost_npr=trekkingData.total_cost_npr
                                :paid="trekkingData.paid"
                                :type="'trekking'"
                                :voucher-number="trekkingData.voucher_number"
                            />

                            <v-flex sm2 lg2>
                                <v-chip v-if="trekkingData.payment_status == 1" color="primary" text-color="white">
                                    Paid
                                </v-chip>
                                <v-chip v-else-if="trekkingData.payment_status == 0" color="red" text-color="white">
                                    Un-paid
                                </v-chip>
                            </v-flex>
                            <v-flex sm12 lg12 v-if="trekkingData.payment_status == 1">
                                <v-layout row wrap>
                                    <v-flex sm4 lg4>
                                        <list-item-detail :sub_title="trekkingData.payment_channel"
                                                          title="Payment Channel"/>
                                    </v-flex>
                                    <v-flex sm4 lg4>
                                        <list-item-detail title="Payment Reference Id"
                                                          :sub_title="trekkingData.payment_reference_id"/>
                                    </v-flex>
                                    <v-flex sm4 lg4>
                                        <v-list v-if="trekkingData.payment_proof">
                                            <v-list-item href="#">
                                                <v-list-item-content>
                                                    <v-btn
                                                        no-caps
                                                        color="info"
                                                        :href="trekkingData.payment_proof"
                                                        target="_blank"
                                                    >
                                                        <v-icon left>mdi mdi-attachment</v-icon>
                                                        Payment Proof
                                                    </v-btn>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>

                <v-footer class="sticky" color="blue darken-1" fixed height="auto">
                    <v-layout row wrap>
                        <v-spacer/>
                        <v-btn @click="payThroughFCGO" :loading="loading" class="text-white" color="blue mr-2"
                               v-if="trekkingData.voucher_generated && trekkingData.voucher_number && !trekkingData.paid">
                            Pay Online
                        </v-btn>
                        <v-btn @click="checkPayment" :loading="loading" class="text-white" color="blue mr-2"
                               v-if="trekkingData.voucher_generated && !trekkingData.paid">
                            Check payment status
                        </v-btn>
                        <v-btn
                            v-if="(trekkingData.paid || parseFloat(trekkingData.total_cost) === 0.00) && trekkingData.status ==='Approved'"
                            @click="download('permit')"
                            class="text-white"
                            color="blue lighten-1 ml-2"
                            :loading="loading"
                        >
                            Download Permit
                        </v-btn>
                        <v-btn
                            @click="print('permit')"
                            class="text-white"
                            color="blue lighten-1 ml-2"
                            v-if="(trekkingData.paid || parseFloat(trekkingData.total_cost) === 0.00) && trekkingData.status ==='Approved'">
                            Print Permit
                        </v-btn>
                    </v-layout>
                </v-footer>
            </v-flex>
        </v-layout>

        <v-layout class="show-on-print" v-if="trekkingData.status === 'Approved'">
            <print-permit :schedule="trekkingData.schedule" :total_cost="trekkingData.total_cost"
                          :trekkers="trekkingData.trekkers"
                          :trekking-route="trekkingData.trekkingRoute" :trekkingAgency="trekkingData.trekkingAgency"
                          :trekkingData="trekkingData" :user="user"
                          style="display: none"
            />
        </v-layout>
    </v-container>
</template>
<style scoped>

.v-btn--floating.v-btn--small .v-icon {
    line-height: -moz-block-height;
}
</style>

<script>
import {mapActions, mapGetters} from "vuex";
import ListItemDetail from '../../components/ListItemDetail';
import ConfirmationHeaderText from '../../components/ConfirmationHeaderText'
import FileDisplay from "../../components/FileDisplay";
import PrintPermit from "./PrintPermit.vue";
import {SET_PRINT_CONTENT} from "../../store/mutation-type";
import PaymentDetail from "../../components/trekkingRequest/PaymentDetail.vue";
import FileListItemDetail from "../../components/FileListItemDetail.vue";

export default {
    components: {FileListItemDetail, PaymentDetail, FileDisplay, ListItemDetail, ConfirmationHeaderText, PrintPermit},
    props: {
        id: String
    },
    computed: {
        ...mapGetters("TrekkingSingle", ["trekkingData"]),
        user() {
            return this.$store.state.AuthUser;
        },
        loading: {
            get() {
                return this.$store.state.TrekkingSingle.loading;
            },
            set(val) {
                this.$store.commit('TrekkingSingle/setLoading', val);
            }
        }
    },
    methods: {
        ...mapActions("TrekkingSingle", [
            "resetState",
            "getTrekkingRequestDetail",
            "updatePaymentStatus",
            "proceedOnlinePayment",
            "checkPaymentStatus"
        ]),
        checkPayment() {
            this.loading = true;
            this.checkPaymentStatus({submission_number: this.trekkingData.id}).then(() => {
                this.loading = false;
                this.getTrekkingRequestDetail(this.id)
                this.$store.commit('Notification/showSuccess', 'Amount has been paid')
            }).catch((err) => {
                this.loading = false;
                this.$store.commit('Notification/showError', 'Not paid')
            });
        },
        print(type) {
            if (type === 'voucher') {
                const content = document.getElementById('voucher_print_content').innerHTML;
                console.log('content', content)
                this.$store.commit(SET_PRINT_CONTENT, content)
            }
            if (type === 'permit') {
                const content = document.getElementById('permit_content').innerHTML;
                this.$store.commit(SET_PRINT_CONTENT, content)
            }
        },
        async payThroughFCGO() {
            this.loading = true;
            try {
                const response = await this.proceedOnlinePayment({
                    submission_number: this.trekkingData.id
                });

                this.postToFCGO(response.data);
            } catch (error) {
                this.$store.commit('Notification/showError', error.response.data.message);
            } finally {
                this.loading = false;
            }
        },
        postToFCGO(data) {
            const form = document.createElement("form");
            form.setAttribute("method", "POST");
            form.setAttribute("action", data.api_url);
            form.setAttribute("target", "_blank");

            const params = {
                code: data.code,
                token: data.token,
                sessionId: data.sessionId,
                lang: "np",
            };

            Object.entries(params).forEach(([key, value]) => {
                const input = document.createElement("input");
                input.setAttribute("type", "text");
                input.setAttribute("name", key);
                input.setAttribute("value", value);
                form.appendChild(input);
            });


            document.body.appendChild(form);

            form.submit();
            document.body.removeChild(form);
        },
        download() {
            this.$store.dispatch("TrekkingSingle/downloadPermit");
        }
    },
    watch: {
        "$route.params.type": function () {
            this.getTrekkingRequestDetail(this.id);
        }
    },
    mounted() {
        this.getTrekkingRequestDetail(this.id);
    },
    destroyed() {
        this.resetState();
    }
};
</script>
